import { SharedDepsClient } from '@indeed/frontend-shared-deps-loader/dist/api/client';
/*
 * Dynamically create an async script tag for each Provider
 **/
export const loadScript = (path) => {
    return SharedDepsClient.v1.load('js', { urls: [path] });
};
export const loadStyle = (path) => {
    return SharedDepsClient.v1.load('css', { urls: [path] });
};
